/**
 * MembershipCard.js — Hestan Vineyards membership card.
 *
 * OVERRIDES: src/components/base/MembershipCard.js
 *
 * Old createWineMembership (main.js): cover_image_link || defaultCardLogo
 * (goose-bkg.webp). When the membership response has no cover, always show
 * theme.card_logo_url / membership_card_image (or the local goose-bkg asset).
 */

import BaseMembershipCard from "../../../components/base/MembershipCard.js";
import { getTheme } from "../../../core/configAccessors.js";
import { ASSETS_BASE_URL } from "../../../core/env.js";
import { emit } from "../../../core/state.js";

function resolveLogoSrc() {
  const logo =
    getTheme("card_logo_url") || getTheme("membership_card_image") || null;
  if (!logo) {
    return `${ASSETS_BASE_URL}/assets/goosecross/goose-bkg.webp`;
  }
  if (/^https?:\/\//i.test(logo)) return logo;
  return `${ASSETS_BASE_URL}${logo}`;
}

export default class HestanMembershipCard extends BaseMembershipCard {
  render(club) {
    const card = super.render(club);
    const head = card.querySelector(".ws-card-head");
    const cover = String(club?.cover_image_link || "").trim();

    // Membership has a real cover — leave base render alone.
    if (cover && head?.querySelector("img")) return card;

    // No cover (or base left head empty) → force default Goose logo.
    if (!head) return card;

    let img = head.querySelector("img");
    if (!img) {
      img = document.createElement("img");
      img.className = "ws-card-img";
      img.alt = club.title || "Membership";
      img.loading = "lazy";
      img.style.cursor = "pointer";
      const label =
        club.message || `Tell me more about ${club.title || "this membership"}`;
      img.addEventListener("click", () =>
        emit("ws-prompt-select", {
          label,
          value: label,
          uniqueId: club.unique_id,
        }),
      );
      head.appendChild(img);
    }

    img.src = resolveLogoSrc();
    img.classList.add("ws-rich-mem-logo");
    return card;
  }
}
